class FjSkulabsCheck {
  static CHECK_ADD_URL = 'https://skulabs-check.onrender.com/check-add';
  static AVAILABILITY_URL = 'https://skulabs-check.onrender.com/check-availability';
  static DEFAULT_MESSAGE =
    "Sorry, we don't have enough raw material to add that size with the items already in your cart.";

  constructor() {
    this.variants = this.parseVariants();
    document.addEventListener('fj:cart:before-add', this.onBeforeAdd.bind(this));
    document.addEventListener('shopify:section:load', () => {
      this.variants = this.parseVariants();
      this.checkAvailability();
    });
    this.checkAvailability();
  }

  parseVariants() {
    const script = document.querySelector('[data-product-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  // Kit sizes are identified by the SKU's last segment: -500/-0500 or -1000.
  getKitMl(sku) {
    if (!sku) return 0;
    const size = sku.split('-').pop().padStart(4, '0');
    if (size === '0500') return 500;
    if (size === '1000') return 1000;
    return 0;
  }

  async checkAvailability() {
    const kitVariants = this.variants.filter((variant) => this.getKitMl(variant.sku) > 0);
    if (!kitVariants.length) return;

    try {
      const url = `${FjSkulabsCheck.AVAILABILITY_URL}?sku=${encodeURIComponent(kitVariants[0].sku)}`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`check-availability returned ${response.status}`);

      const { availableMl } = await response.json();
      if (availableMl === null || availableMl === undefined) return;

      kitVariants.forEach((variant) => {
        if (this.getKitMl(variant.sku) > availableMl) this.disableVariant(variant);
      });
      this.selectFirstEnabledIfNeeded();
    } catch (e) {
      console.error('[SKULabs] Availability check failed:', e);
    }
  }

  // Kit products have a single option (Size), so one button maps to one variant.
  disableVariant(variant) {
    if (variant.options.length !== 1) return;
    document.querySelectorAll('[data-size-option], [data-sticky-size-option]').forEach((btn) => {
      if (btn.dataset.optionIndex === '0' && btn.dataset.value === variant.options[0]) {
        btn.disabled = true;
      }
    });
  }

  selectFirstEnabledIfNeeded() {
    const selected = document.querySelector('[data-size-option].is-selected');
    if (!selected?.disabled) return;
    document.querySelector('[data-size-option]:not(:disabled)')?.click();
  }

  onBeforeAdd(event) {
    const { sku, quantity, productTitle, addCheck } = event.detail;
    if (!this.getKitMl(sku)) return;
    addCheck(this.checkAdd(sku, quantity, productTitle));
  }

  // Always resolves; fails open (allows the add) if anything goes wrong.
  async checkAdd(sku, quantity, productTitle) {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(`cart.js returned ${cartResponse.status}`);
      const cart = await cartResponse.json();

      const payload = {
        cartLines: cart.items.map((item) => ({
          sku: item.sku || null,
          quantity: item.quantity || 0,
          productName: item.product_title || item.title || null,
        })),
        newLine: { sku, quantity, productName: productTitle || null },
      };

      const response = await fetch(FjSkulabsCheck.CHECK_ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`check-add returned ${response.status}`);

      const result = await response.json();
      if (result?.allow === false) {
        this.checkAvailability();
        return { allow: false, message: result.message || FjSkulabsCheck.DEFAULT_MESSAGE };
      }
      return { allow: true };
    } catch (e) {
      console.error('[SKULabs] Add check failed; allowing add:', e);
      return { allow: true };
    }
  }
}

new FjSkulabsCheck();